import {useMutation} from 'react-query';
import {PatchBannerClickCount} from './patchBannerClickCount';

const usePatchBannerClickCount = () => {
  const {isLoading, mutate, isSuccess} = useMutation({
    mutationFn: (bannerGuid: string) => PatchBannerClickCount(bannerGuid),
  });

  return {isLoading, addBannerCount: mutate, isSuccess};
};

export default usePatchBannerClickCount;
